<template>
  <modal :modal-key="'loading'" @close="$emit('close')" class="modal--welcomeback modal--zero-balance">
    <template slot="header">
      <h1>{{ getTranslations.home_modals_loading_please_wait }}</h1>
      <img class="pinicon" src="static/images/resubscribe_pin.png" alt="">
    </template>
    <template slot="body">
      <div class="loader-contv1">
        <div class="loader-cont__wrapperv1">
          <div class="loaderv1"></div>
        </div>
      </div>
    </template>
  </modal>
</template>

<script>
import { mapGetters } from 'vuex';
import Modal from '@/components/home/modals/shared/GenericModal';

export default {
  name: 'loading',
  components: {
    Modal,
  },
  computed: {
    ...mapGetters('i18n', [
      'getTranslations',
    ]),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/home/modals/shared/Loading.vue